module.exports = __webpack_public_path__ + "assets/img/1688.f3914328.png";